import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OwnStrategiesComponent } from 'src/app/pages/own-strategies/own-strategies.component';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

const routes: Routes = [
  {
    path: '',
    component: OwnStrategiesComponent,
    canActivate: [AuthenticationService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OwnStrategiesRoutingModule { }
